"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BuySellDesktopLayout", {
  enumerable: true,
  get: function get() {
    return _BuySellDesktopLayout["default"];
  }
});
Object.defineProperty(exports, "BuySellMobileLayout", {
  enumerable: true,
  get: function get() {
    return _BuySellMobileLayout["default"];
  }
});
Object.defineProperty(exports, "BuySellTabletsLayout", {
  enumerable: true,
  get: function get() {
    return _BuySellTabletsLayout["default"];
  }
});
var _BuySellDesktopLayout = _interopRequireDefault(require("./BuySellDesktopLayout"));
var _BuySellTabletsLayout = _interopRequireDefault(require("./BuySellTabletsLayout"));
var _BuySellMobileLayout = _interopRequireDefault(require("./BuySellMobileLayout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }